import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-custom-sidebar-channel',
  templateUrl: './custom-sidebar-channel.component.html',
  styleUrls: ['./custom-sidebar-channel.component.scss'],
})
export class CustomSidebarChannelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
